// extracted by mini-css-extract-plugin
export var indeterminate = "_52-6";
export var md = "_52-5";
export var semantic = "_52-7";
export var sm = "_52-4";
export var text = "_52-8";
export var toggleControl = "_52-0";
export var toggleInput = "_52-1";
export var toggleSwitch = "_52-2";
export var xs = "_52-3";